module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f6f98a31ec06445bd1c27a3187ae25f0.png";